export default __webpack_public_path__ + "static/media/arrow-left.1c39f672.svg";